import { MapPin, Phone, Clock, ExternalLink, Mail } from "lucide-react";
import { Reveal } from "../motion/Reveal.jsx";

export default function LocationCard({ club, testId }) {
  const mapLink =
    club.mapUrl ||
    (club.address ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(club.address)}` : null);
  return (
    <Reveal data-testid={testId} className="flex h-full flex-col gap-5 rounded-xl border border-hairline bg-white p-8">
      <div className="flex items-center justify-between">
        <h3 className="font-display text-3xl text-navy">{club.name}</h3>
        <span className="font-display text-xl text-faint">{club.index}</span>
      </div>
      <ul className="flex flex-col gap-3 text-sm leading-relaxed text-body">
        <li className="flex items-start gap-3">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
          {club.address ? (
            <a data-testid={`${testId}-address`} href={mapLink} target="_blank" rel="noopener noreferrer" className="underline-offset-4 hover:text-brand hover:underline">
              {club.address}
            </a>
          ) : (
            <span className="text-mute italic">{club.addressNote || "Location details updating soon"}</span>
          )}
        </li>
        <li className="flex items-start gap-3">
          <Phone className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
          {club.phone ? (
            <a data-testid={`${testId}-phone`} href={club.phoneHref} className="underline-offset-4 hover:text-brand hover:underline">
              {club.phone}
            </a>
          ) : (
            <span className="text-mute italic">Phone updating soon</span>
          )}
        </li>
        {club.email && (
          <li className="flex items-start gap-3" data-testid={`${testId}-email`}>
            <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
            <a href={`mailto:${club.email}`} className="underline-offset-4 hover:text-brand hover:underline">
              {club.email}
            </a>
          </li>
        )}
        <li className="flex items-start gap-3">
          <Clock className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
          {club.timings ? <span>{club.timings}</span> : <span className="text-mute italic">Timings updating soon</span>}
        </li>
      </ul>
      {mapLink && (
        <a
          data-testid={`${testId}-map-link`}
          href={mapLink}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-auto inline-flex items-center gap-2 border-t border-hairline pt-4 text-[11px] font-bold uppercase tracking-[0.2em] text-navy transition-colors hover:text-brand"
        >
          Open Map <ExternalLink className="h-3.5 w-3.5" />
        </a>
      )}
    </Reveal>
  );
}
